import Api from '../functions/api';
import { serialize } from '../functions/objectToQuery';

const criar = (body) => {
  return Api.post('/UsuarioInstituicaoDeEnsino', body);
};

const excluir = (id) => {
  return Api.del(`/UsuarioInstituicaoDeEnsino/${id}`);
};

const obterFiltrado = (params) => {
  return Api.get(`/UsuarioInstituicaoDeEnsino/?${serialize(params)}`);
};

export const UsuarioInstituicaoStore = {
  criar,
  excluir,
  obterFiltrado,
};
